import { Box, FormControl, FormControlLabel, FormLabel, Input, InputLabel, MenuItem, Radio, RadioGroup, Select, Stack } from "@mui/material";
import { useState } from "react";
import { checkDoublePattern, checkIntPattern, checkPercentagePattern } from "../../utils/commons";

const FormRedRiegoComponent = ({position, setPosition, state, setState}) => {

    const [errors, setErrors] = useState({});

    const handleNext = (e) => {
        e.preventDefault();
        if(validateForm()){
            setPosition(3);
        }
    };
    const handlePrev = (e) => {
        e.preventDefault();
        setPosition(1);
    }

    const handleChangeNumTiposMacrotunel = (e) => {

        // Si no es un número válido, no hace nada
        if (e !== "" && !checkIntPattern(e)) {
            return; 
        }

        const nuevaCantidad = parseInt(e, 10) || 0;
        
        setState((prevState) => {
            const tiposActuales = prevState.tiposMTunel || [];
            const diferencia = nuevaCantidad - tiposActuales.length;
            let nuevosTipos = [...tiposActuales];

            if (diferencia > 0) {
                const nuevosPaneles = Array.from({ length: diferencia }, () => ({ 
                    tubLaterales: "", 
                    lonLomo: "", 
                    numLomos: "", 
                    sepLomos: "", 
                    distGoteros: "", 
                    caudalNom: "", 
                    numMacroTuneles: "" 
                }));
                nuevosTipos = [...nuevosTipos, ...nuevosPaneles];
            } else if (diferencia < 0) {
                nuevosTipos = tiposActuales.slice(0, nuevaCantidad);
            }

            // Retorna el objeto de estado completo modificado
            return {
                ...prevState,
                numTiposMTunel: e,
                tiposMTunel: nuevosTipos
            };
        });

    };

    const handleChangePanelValue = (indexModificar, propiedad, valor) => {

        setState((prevState) => {
            const tiposActualizados = prevState.tiposMTunel.map((panel, index) => {
                // Si es el panel que el usuario está editando, actualiza su propiedad
                if (index === indexModificar) {
                    return { ...panel, [propiedad]: valor };
                }
                // Los demás paneles se quedan exactamente igual
                return panel;
            });

            // Retorna el objeto de estado completo modificado
            return {
                ...prevState,
                tiposMTunel: tiposActualizados
            };
        });

    };


    const handleTipoRiego = (e) => {
        if(e === "Goteros equidistantes"){
            setState({...state, tipoRiego: e, nGoteros: ""});
        }else if(e === "Goteros por árbol"){
            setState({...state, tipoRiego: e, nRamales: "", distanciaGoteros: ""});
        }
    }

    const handleChangeNRamales = (e) => {
        if(checkIntPattern(e)){
            setState({...state, nRamales: e});
        }
    }

    const handleChangeDistanciaGoteros = (e) => {
        if(checkDoublePattern(e)){
            setState({...state, distanciaGoteros: e});
        }
    }

    const handleChangeNGoteros = (e) => {
        if(checkIntPattern(e)){
            setState({...state, nGoteros: e});
        }
    }

    const handleChangeCaudalGotero = (e) => {
        if(checkDoublePattern(e)){
            setState({...state, caudalGotero: e});
        }
    }

    const handleChangeSuperficieSector = (e) => {
        if(checkDoublePattern(e)){
            setState({...state, superficieSector: e});
        }
    }

    const handleChangeRiegoACubrir = (e) => {
        if(checkPercentagePattern(e)){
            setState({...state, riegoACubrir: e});
        }
    }

    const handleChangeTipoEstrategia = (e) => {
        if(e === "Riego deficitario sostenido (RDS)"){
            setState({...state, tipoEstrategia: e});
        }else{
            setState({...state, tipoEstrategia: e, riegoACubrir: ""});
        }
    }

    const validateForm = () =>{

        setErrors({});
        let inputIds = "";
        let valid = true;

        if(state.tipoCultivo === "olivar" || state.tipoCultivo === "citricos") {

            if(state.tipoRiego === undefined || state.tipoRiego === ''){

                setErrors(errors => ({...errors, errorTipoRiego: true, errorTipoRiegoMsg: "Debe elegir un tipo de riego por goteo."}));
                inputIds = inputIds ? inputIds +",tipoRiego" : "tipoRiego";
                valid = false;

            } else if(state.tipoRiego === "Goteros equidistantes"){

                if(state.nRamales === undefined || state.nRamales === ''){
                    setErrors(errors => ({...errors, errorNRamales: true, errorNRamalesMsg: ""}));
                    inputIds = inputIds ? inputIds +",nRamales" : "nRamales";
                    valid = false;
                }else if(!(checkIntPattern(state.nRamales))){
                    setErrors(errors => ({...errors, errorNRamales: true, errorNRamalesMsg: "Debe ser un valor numérico."}));
                    inputIds = inputIds ? inputIds +",nRamales" : "nRamales";
                    valid = false;
                }
                if(state.distanciaGoteros === undefined || state.distanciaGoteros === ''){
                    setErrors(errors => ({...errors, errorDistanciaGoteros: true, errorDistanciaGoterosMsg: ""}));
                    inputIds = inputIds ? inputIds +",distanciaGoteros" : "distanciaGoteros";
                    valid = false;
                }else if(!(checkDoublePattern(state.distanciaGoteros))){
                    setErrors(errors => ({...errors, errorDistanciaGoteros: true, errorDistanciaGoterosMsg: "Debe ser un valor numérico."}));
                    inputIds = inputIds ? inputIds +",distanciaGoteros" : "distanciaGoteros";
                    valid = false;
                }

            }else if(state.tipoRiego === "Goteros por árbol"){

                if(state.nGoteros === undefined || state.nGoteros === ''){
                    setErrors(errors => ({...errors, errorNGoteros: true, errorNGoterosMsg: ""}));
                    inputIds = inputIds ? inputIds +",nGoteros" : "nGoteros";
                    valid = false;
                }else if(!(checkIntPattern(state.nGoteros))){
                    setErrors(errors => ({...errors, errorNGoteros: true, errorNGoterosMsg: "Debe ser un valor numérico."}));
                    inputIds = inputIds ? inputIds +",nGoteros" : "nGoteros";
                    valid = false;
                }

            }if(state.caudalGotero === undefined || state.caudalGotero === ''){

                setErrors(errors => ({...errors, errorCaudalGotero: true, errorCaudalGoteroMsg: ""}));
                inputIds = inputIds ? inputIds +",caudalGotero" : "caudalGotero";
                valid = false;

            }else if(!(checkDoublePattern(state.caudalGotero))){

                setErrors(errors => ({...errors, errorCaudalGotero: true, errorCaudalGoteroMsg: "Debe ser un valor numérico."}));
                inputIds = inputIds ? inputIds +",caudalGotero" : "caudalGotero";
                valid = false;

            }

            if(state.superficieSector === undefined || state.superficieSector === ''){

                setErrors(errors => ({...errors, errorSuperficieSector: true, errorSuperficieSectorMsg: ""}));
                inputIds = inputIds ? inputIds +",superficieSector" : "superficieSector";
                valid = false;

            }else if(!(checkDoublePattern(state.superficieSector))){

                setErrors(errors => ({...errors, errorSuperficieSector: true, errorSuperficieSectorMsg: "Debe ser un valor numérico."}));
                inputIds = inputIds ? inputIds +",superficieSector" : "superficieSector";
                valid = false;

            }

        }


        if(state.tipoCultivo === "fresa") {

            //(La estrategia de riego no se usa en fresa: FormEnd la envía vacía. Antes se ponía a null mutando el estado)

            //(La distancia del contador al final del ramal se pide y valida en FormEnd, solo para Usuario 4.0)

            //Hace falta al menos un tipo de macrotúnel (antes no se avanzaba, pero sin ningún mensaje)
            const tiposMTunel = state.tiposMTunel || [];
            if (tiposMTunel.length === 0) {
                setErrors(errors => ({...errors, errornumTiposMTunel: true, errorTiposMTunelMsg: "Debe indicar al menos un tipo de macrotúnel."}));
                inputIds = inputIds ? inputIds +",numTiposMTunel" : "numTiposMTunel";
                valid = false;
            }

            tiposMTunel.forEach((panel, index) => {

                if(panel.tubLaterales === undefined || panel.tubLaterales === ''){

                    setErrors(prevErrors => ({...prevErrors,tubLaterales: {...(prevErrors.tubLaterales || {}),[index]: true}, tubLateralesMsg: {...(prevErrors.tubLateralesMsg || {}),[index]: "Este campo es obligatorio"} }));
                    inputIds = inputIds ? `${inputIds},tubLaterales-${index}` : `tubLaterales-${index}`;
                    valid = false;

                }else if(panel.tubLaterales !== "1" && panel.tubLaterales !== "2"){

                    setErrors(prevErrors => ({...prevErrors,tubLaterales: {...(prevErrors.tubLaterales || {}),[index]: true}, tubLateralesMsg: {...(prevErrors.tubLateralesMsg || {}),[index]: "Debe ser 1 o 2"} }));
                    inputIds = inputIds ? `${inputIds},tubLaterales-${index}` : `tubLaterales-${index}`;
                    valid = false;

                }

                if(panel.lonLomo === undefined || panel.lonLomo === ''){

                    setErrors(prevErrors => ({...prevErrors,lonLomo: {...(prevErrors.lonLomo || {}),[index]: true}, lonLomoMsg: {...(prevErrors.lonLomoMsg || {}),[index]: "Este campo es obligatorio"} }));
                    inputIds = inputIds ? `${inputIds},lonLomo-${index}` : `lonLomo-${index}`;
                    valid = false;

                }

                if(panel.numLomos === undefined || panel.numLomos === ''){

                    setErrors(prevErrors => ({...prevErrors,numLomos: {...(prevErrors.numLomos || {}),[index]: true}, numLomosMsg: {...(prevErrors.numLomosMsg || {}),[index]: "Este campo es obligatorio"} }));
                    inputIds = inputIds ? `${inputIds},numLomos-${index}` : `numLomos-${index}`;
                    valid = false;

                }

                if(panel.sepLomos === undefined || panel.sepLomos === ''){

                    setErrors(prevErrors => ({...prevErrors,sepLomos: {...(prevErrors.sepLomos || {}),[index]: true}, sepLomosMsg: {...(prevErrors.sepLomosMsg || {}),[index]: "Este campo es obligatorio"} }));
                    inputIds = inputIds ? `${inputIds},sepLomos-${index}` : `sepLomos-${index}`;
                    valid = false;

                }
                
                if(panel.distGoteros === undefined || panel.distGoteros === ''){

                    setErrors(prevErrors => ({...prevErrors,distGoteros: {...(prevErrors.distGoteros || {}),[index]: true}, distGoterosMsg: {...(prevErrors.distGoterosMsg || {}),[index]: "Este campo es obligatorio"} }));
                    inputIds = inputIds ? `${inputIds},distGoteros-${index}` : `distGoteros-${index}`;
                    valid = false;

                }else if(!(parseFloat(String(panel.distGoteros).replace(",", ".")) > 0)){

                    //Se usa para dividir (goteros por metro de cinta = 1 / distancia)
                    setErrors(prevErrors => ({...prevErrors,distGoteros: {...(prevErrors.distGoteros || {}),[index]: true}, distGoterosMsg: {...(prevErrors.distGoterosMsg || {}),[index]: "Debe ser mayor que 0"} }));
                    inputIds = inputIds ? `${inputIds},distGoteros-${index}` : `distGoteros-${index}`;
                    valid = false;

                }
                
                if(panel.caudalNom === undefined || panel.caudalNom === ''){

                    setErrors(prevErrors => ({...prevErrors,caudalNom: {...(prevErrors.caudalNom || {}),[index]: true}, caudalNomMsg: {...(prevErrors.caudalNomMsg || {}),[index]: "Este campo es obligatorio"} }));
                    inputIds = inputIds ? `${inputIds},caudalNom-${index}` : `caudalNom-${index}`;
                    valid = false;

                }

                if(panel.numMacroTuneles === undefined || panel.numMacroTuneles === ''){

                    setErrors(prevErrors => ({...prevErrors,numMacroTuneles: {...(prevErrors.numMacroTuneles || {}),[index]: true}, numMacroTunelesMsg: {...(prevErrors.numMacroTunelesMsg || {}),[index]: "Este campo es obligatorio"} }));
                    inputIds = inputIds ? `${inputIds},numMacroTuneles-${index}` : `numMacroTuneles-${index}`;
                    valid = false;

                }

            });

        }

        //Tomate: tuberías por línea (1 o 2), separación entre líneas, distancia entre goteros, caudal y superficie.
        //El backend los usa todos para calcular el caudal del sector (antes no se validaba ninguno)
        if(state.tipoCultivo === "tomate") {

            if(state.nRamales !== "1" && state.nRamales !== "2"){
                setErrors(errors => ({...errors, nRamales: true, nRamalesMsg: state.nRamales ? "Debe ser 1 o 2." : "Este campo es obligatorio."}));
                inputIds = inputIds ? inputIds +",nRamales" : "nRamales";
                valid = false;
            }

            [["sepLineasRiego", "la separación entre líneas de riego"], ["distanciaGoteros", "la distancia entre goteros"],
             ["caudalGotero", "el caudal nominal del emisor"], ["superficieSector", "la superficie del sector"]].forEach(([campo, nombre]) => {
                const valor = parseFloat(String(state[campo] ?? "").replace(",", "."));
                if(!(valor > 0)){
                    setErrors(errors => ({...errors, [campo]: true, [campo + "Msg"]: state[campo] ? "Debe ser mayor que 0." : "Debe indicar " + nombre + "."}));
                    inputIds = inputIds ? inputIds + "," + campo : campo;
                    valid = false;
                }
            });

        }

        if(state.tipoCultivo === "olivar" || state.tipoCultivo === "citricos") {

            if(state.tipoEstrategia === undefined || state.tipoEstrategia === ''){

                setErrors(errors => ({...errors, errorTipoEstrategia: true, errorTipoEstrategiaMsg: "Debe elegir una estrategia de riego."}));
                inputIds = inputIds ? inputIds +",tipoEstrategia" : "tipoEstrategia";
                valid = false;

            }

            if(state.tipoEstrategia === "Riego deficitario sostenido (RDS)"){

                if(state.riegoACubrir === undefined || state.riegoACubrir === ''){
                    setErrors(errors => ({...errors, errorRiegoACubrir: true, errorRiegoACubrirMsg: ""}));
                    inputIds = inputIds ? inputIds +",riegoACubrir" : "riegoACubrir";
                    valid = false;
                }

            }

        }

        if(inputIds !== ""){

            try{
                let elem = document.getElementById(inputIds.split(",")[0]);
                elem.scrollIntoView({behavior: "smooth"});
                elem.focus();
            }catch(err){

            }

        }

        return valid;
    }
    
    return(
        <>
        <Box className={position !== 2 && 'hide'}>
            <h2>Características de la Red de Riego</h2>

                {(state.tipoCultivo === "fresa" ) &&
                <>

                    {/* <FormControl sx={{width: "100%", marginBottom: "20px"}} variant="standard">
                            <InputLabel htmlFor="dotacionRiego">Dotación de riego (m3/ha)*</InputLabel>
                            <Input
                                id="dotacionRiego"
                                className="t4b-finca-sector-inputs"
                                label="Dotación de riego (m3/ha)"
                                value={state.dotacionRiego || ""}
                                onChange={(e) => {
                                    if(checkDoublePattern(e.target.value)){
                                        setState({...state, dotacionRiego: e.target.value});
                                    }
                                }}
                                required
                                name="dotacionRiego"
                                error={errors.errordotacionRiego}
                            />
                            {errors && errors.errordotacionRiegoMsg && <div className="errorMsg">{errors.errordotacionRiegoMsg}</div>}
                    </FormControl> */}


                    <FormControl sx={{width: "100%", marginBottom: "20px"}} variant="standard">
                            <InputLabel htmlFor="numTiposMTunel">Número de tipos de macrotúnel*</InputLabel>
                            <Input
                                id="numTiposMTunel"
                                className="t4b-finca-sector-inputs"
                                label="Número de tipos de macrotúnel"
                                value={(state.tiposMTunel || []).length || ""}
                                onChange={(e) => handleChangeNumTiposMacrotunel(e.target.value)}
                                required
                                name="numTiposMTunel"
                                error={errors.errornumTiposMTunel}
                            />
                            {errors && errors.errorTiposMTunelMsg && <div className="errorTiposMTunelMsg">{errors.errorTiposMTunelMsg}</div>}
                    </FormControl>

                    {/* Renderizado dinámico basado en el arreglo del estado */}
                    <div style={{ marginTop: '20px' }}>
                        {(state.tiposMTunel || []).map((panel, index) => (
                        <div key={index} style={{ border: '1px solid #ccc', padding: '10px', marginBottom: '10px' }}>


                            <h4>Tipo de Macrotunel #{index + 1}</h4>

                            {/* TUBERIAS LATERALES POR LOMO */}
                            <FormControl sx={{width: "100%", marginBottom: "20px"}} variant="standard">
                                    <InputLabel htmlFor={`tubLaterales-${index}`}>Tuberías laterales por lomo (1 o 2)*</InputLabel>
                                    <Input
                                        id={`tubLaterales-${index}`}
                                        className="t4b-finca-sector-inputs"
                                        label="Tuberías laterales por lomo (1 o 2)"
                                        value={panel.tubLaterales || ""}
                                        onChange={(e) => {
                                            if(checkIntPattern(e.target.value)){
                                                handleChangePanelValue(index, "tubLaterales", e.target.value);
                                            }
                                        }}
                                        required
                                        name="tubLaterales"
                                        error={Boolean(errors && errors.tubLaterales && errors.tubLaterales[index])}
                                    />
                                    {errors && errors.tubLateralesMsg && errors.tubLateralesMsg[index] && <div className="errorInput">{errors.tubLateralesMsg[index]}</div>}
                            </FormControl>

                            {/* LONGITUD DEL LOMO */}
                            <FormControl sx={{width: "100%", marginBottom: "20px"}} variant="standard">
                                    <InputLabel htmlFor={`lonLomo-${index}`}>Longitud del Lomo (m)*</InputLabel>
                                    <Input
                                        id={`lonLomo-${index}`}
                                        className="t4b-finca-sector-inputs"
                                        label="Longitud del Lomo (m)"
                                        value={panel.lonLomo || ""}
                                        onChange={(e) => {
                                            if(checkDoublePattern(e.target.value)){
                                                handleChangePanelValue(index, "lonLomo", e.target.value);
                                            }
                                        }}
                                        required
                                        name="lonLomo"
                                        error={Boolean(errors && errors.lonLomo && errors.lonLomo[index])}
                                    />
                                    {errors && errors.lonLomoMsg && errors.lonLomoMsg[index] && <div className="errorInput">{errors.lonLomoMsg[index]}</div>}
                            </FormControl>

                            {/* NUMERO DE LOMOS */}
                            <FormControl sx={{width: "100%", marginBottom: "20px"}} variant="standard">
                                    <InputLabel htmlFor={`numLomos-${index}`}>Cantidad de lomos*</InputLabel>
                                    <Input
                                        id={`numLomos-${index}`}
                                        className="t4b-finca-sector-inputs"
                                        label="Cantidad de lomos"
                                        value={panel.numLomos || ""}
                                        onChange={(e) => {
                                            if(checkIntPattern(e.target.value)){
                                                handleChangePanelValue(index, "numLomos", e.target.value);
                                            }
                                        }}
                                        required
                                        name="numLomos"
                                        autoComplete="off"
                                        error={Boolean(errors && errors.numLomos && errors.numLomos[index])} //{errors.errornumLomos}
                                    />
                                    {errors && errors.numLomosMsg && errors.numLomosMsg[index] && <div className="errorInput">{errors.numLomosMsg[index]}</div>}
                            </FormControl>

                            {/* NUMERO DE LOMOS */}
                            <FormControl sx={{width: "100%", marginBottom: "20px"}} variant="standard">
                                    <InputLabel htmlFor={`sepLomos-${index}`}>Separación entre lomos (m)*</InputLabel>
                                    <Input
                                        id={`sepLomos-${index}`}
                                        className="t4b-finca-sector-inputs"
                                        label="Separación entre lomos (m)"
                                        value={panel.sepLomos || ""}
                                        onChange={(e) => {
                                            if(checkDoublePattern(e.target.value)){
                                                handleChangePanelValue(index, "sepLomos", e.target.value);
                                            }
                                        }}
                                        required
                                        name="sepLomos"
                                        error={Boolean(errors && errors.sepLomos && errors.sepLomos[index])}  //{errors.sepLomos}
                                    />
                                    {errors && errors.sepLomosMsg && errors.sepLomosMsg[index] && <div className="errorInput">{errors.sepLomosMsg[index]}</div>}
                            </FormControl>

                            {/* DISTANCIA ENTRE GOTEROS */}
                            <FormControl sx={{width: "100%", marginBottom: "20px"}} variant="standard">
                                    <InputLabel htmlFor={`distGoteros-${index}`}>Distancia entre goteros (m)*</InputLabel>
                                    <Input
                                        id={`distGoteros-${index}`}
                                        className="t4b-finca-sector-inputs"
                                        label="Distancia entre goteros (m)"
                                        value={panel.distGoteros || ""}
                                        onChange={(e) => {
                                            if(checkDoublePattern(e.target.value)){
                                                handleChangePanelValue(index, "distGoteros", e.target.value);
                                            }
                                        }}
                                        required
                                        name="distGoteros"
                                        error={Boolean(errors && errors.distGoteros && errors.distGoteros[index])}  //{errors.distGoteros}
                                    />
                                    {errors && errors.distGoterosMsg && errors.distGoterosMsg[index] && <div className="errorInput">{errors.distGoterosMsg[index]}</div>}
                            </FormControl>

                            {/* CAUDAL NOMINAL */}
                            <FormControl sx={{width: "100%", marginBottom: "20px"}} variant="standard">
                                    <InputLabel htmlFor={`caudalNom-${index}`}>Caudal nominal del emisor (l/h)*</InputLabel>
                                    <Input
                                        id={`caudalNom-${index}`}
                                        className="t4b-finca-sector-inputs"
                                        label="Caudal nominal del emisor (l/h)"
                                        value={panel.caudalNom || ""}
                                        onChange={(e) => {
                                            if(checkDoublePattern(e.target.value)){
                                                handleChangePanelValue(index, "caudalNom", e.target.value);
                                            }
                                        }}
                                        required
                                        name="caudalNom"
                                        error={Boolean(errors && errors.caudalNom && errors.caudalNom[index])} //{errors.caudalNom}
                                    />
                                    {errors && errors.caudalNomMsg && errors.caudalNomMsg[index] && <div className="errorInput">{errors.caudalNomMsg[index]}</div>}
                            </FormControl>

                            {/* NUMERO DE MACROTUNELES DE ESTE TIPO */}
                            <FormControl sx={{width: "100%", marginBottom: "20px"}} variant="standard">
                                    <InputLabel htmlFor={`numMacroTuneles-${index}`}>Número de macrotúneles de este tipo*</InputLabel>
                                    <Input
                                        id={`numMacroTuneles-${index}`}
                                        className="t4b-finca-sector-inputs"
                                        label="Número de macro túneles de este tipo"
                                        value={panel.numMacroTuneles || ""}
                                        onChange={(e) => {
                                            if(checkIntPattern(e.target.value)){
                                                handleChangePanelValue(index, "numMacroTuneles", e.target.value);
                                            }
                                        }}
                                        required
                                        name="numMacroTuneles"
                                        error={Boolean(errors && errors.numMacroTuneles && errors.numMacroTuneles[index])} //{errors.numMacroTuneles}
                                    />
                                    {errors && errors.numMacroTunelesMsg && errors.numMacroTunelesMsg[index] && <div className="errorInput">{errors.numMacroTunelesMsg[index]}</div>}
                            </FormControl>

                        </div>
                        ))}
                    </div>


                </>
                }


                {(state.tipoCultivo === "tomate" ) &&
                <>

                    <FormControl sx={{width: "100%", marginBottom: "20px"}} variant="standard">
                            <InputLabel htmlFor="nRamales">Tuberías laterales por línea de cultivo (1 o 2)*</InputLabel>
                            <Input
                                id="nRamales"
                                className="t4b-finca-sector-inputs"
                                label="Tuberías laterales por línea de cultivo (1 o 2)"
                                value={state.nRamales || ""}
                                onChange={(e) => {
                                    if(checkIntPattern(e.target.value)){
                                        setState({...state, nRamales: e.target.value});
                                    }
                                }}
                                required
                                name="nRamales"
                                error={errors.nRamales}
                            />
                            {errors && errors.nRamalesMsg && <div className="errorMsg">{errors.nRamalesMsg}</div>}
                    </FormControl>

                    <FormControl sx={{width: "100%", marginBottom: "20px"}} variant="standard">
                            <InputLabel htmlFor="sepLineasRiego">Separación entre líneas de riego (m)*</InputLabel>
                            <Input
                                id="sepLineasRiego"
                                className="t4b-finca-sector-inputs"
                                label="Separación entre líneas de riego"
                                value={state.sepLineasRiego || ""}
                                onChange={(e) => {
                                    if(checkDoublePattern(e.target.value)){
                                        setState({...state, sepLineasRiego: e.target.value});
                                    }
                                }}
                                required
                                name="sepLineasRiego"
                                error={errors.sepLineasRiego}
                            />
                            {errors && errors.sepLineasRiegoMsg && <div className="errorMsg">{errors.sepLineasRiegoMsg}</div>}
                    </FormControl>

                    <FormControl sx={{width: "100%", marginBottom: "20px"}} variant="standard">
                            <InputLabel htmlFor="distanciaGoteros">Distancia entre goteros (m)*</InputLabel>
                            <Input
                                id="distanciaGoteros"
                                className="t4b-finca-sector-inputs"
                                label="Distancia entre goteros"
                                value={state.distanciaGoteros || ""}
                                onChange={(e) => {
                                    if(checkDoublePattern(e.target.value)){
                                        setState({...state, distanciaGoteros: e.target.value});
                                    }
                                }}
                                required
                                name="distanciaGoteros"
                                error={errors.distanciaGoteros}
                            />
                            {errors && errors.distanciaGoterosMsg && <div className="errorMsg">{errors.distanciaGoterosMsg}</div>}
                    </FormControl>

                    <FormControl sx={{width: "100%", marginBottom: "20px"}} variant="standard">
                            <InputLabel htmlFor="caudalGotero">Caudal nominal del emisor (l/h)*</InputLabel>
                            <Input
                                id="caudalGotero"
                                className="t4b-finca-sector-inputs"
                                label="Caudal nominal emisor"
                                value={state.caudalGotero || ""}
                                onChange={(e) => {
                                    if(checkDoublePattern(e.target.value)){
                                        setState({...state, caudalGotero: e.target.value});
                                    }
                                }}
                                required
                                name="caudalGotero"
                                error={errors.caudalGotero}
                            />
                            {errors && errors.caudalGoteroMsg && <div className="errorMsg">{errors.caudalGoteroMsg}</div>}
                    </FormControl>

                    <FormControl sx={{width: "100%", marginBottom: "20px"}} variant="standard">
                            <InputLabel htmlFor="superficieSector">Superficie del sector (ha)*</InputLabel>
                            <Input
                                id="superficieSector"
                                className="t4b-finca-sector-inputs"
                                label="Superficie del sector"
                                value={state.superficieSector || ""}
                                onChange={(e) => {
                                    if(checkDoublePattern(e.target.value)){
                                        setState({...state, superficieSector: e.target.value});
                                    }
                                }}
                                required
                                name="superficieSector"
                                error={errors.superficieSector}
                            />
                            {errors && errors.superficieSectorMsg && <div className="errorMsg">{errors.superficieSectorMsg}</div>}
                    </FormControl>

                    

                </>
                }


                {(state.tipoCultivo === "olivar" || state.tipoCultivo === "citricos") &&
                <>
                
                    <FormControl sx={{width: "100%", marginBottom: "20px"}} variant="standard">
                            <InputLabel htmlFor="caudalGotero">Caudal Nominal del Gotero (litros/hora)*</InputLabel>
                            <Input
                                id="caudalGotero"
                                className="t4b-finca-sector-inputs"
                                label="Caudal Nominal del gotero"
                                value={state.caudalGotero}
                                onChange={(e) => handleChangeCaudalGotero(e.target.value)}
                                required
                                name="caudalGotero"
                                error={errors.errorCaudalGotero}
                            />
                            {errors.errorCaudalGoteroMsg && <div className="errorInput">{errors.errorCaudalGoteroMsg}</div>}
                    </FormControl>
                    <FormControl sx={{width: "100%", marginBottom: "20px"}} variant="standard">
                            <InputLabel htmlFor="superficieSector">Superficie del Sector (hectáreas)*</InputLabel>
                            <Input
                                id="superficieSector"
                                className="t4b-finca-sector-inputs"
                                label="Superficie Sector"
                                value={state.superficieSector}
                                onChange={(e) => handleChangeSuperficieSector(e.target.value)}
                                required
                                name="superficieSector"
                                error={errors.errorSuperficieSector}
                            />
                            {errors.errorSuperficieSectorMsg && <div className="errorInput">{errors.errorSuperficieSectorMsg}</div>}
                    </FormControl>

                    <FormControl sx={{width: "100%", marginBottom: "20px"}} className="radio-green" variant="standard">
                        <FormLabel htmlFor="tipoRiego">Sistema de Riego por Goteo*</FormLabel>
                        <RadioGroup
                            name="tipoRiego"
                            id="tipoRiego"
                            value={state.tipoRiego}
                            onChange={(e) => handleTipoRiego(e.target.value)}
                            error={errors.errorTipoRiego ? "true" : ""}
                        >
                            <FormControlLabel value="Goteros equidistantes" control={<Radio />} label="Goteros equidistantes" />
                            <FormControlLabel value="Goteros por árbol" control={<Radio />} label="Goteros por árbol" />
                        </RadioGroup>
                        {errors.errorTipoRiegoMsg && <div className="errorMsg">{errors.errorTipoRiegoMsg}</div>}
                    </FormControl>
                    {state.tipoRiego === "Goteros equidistantes" && (
                    <>
                        <FormControl sx={{width: "100%", marginBottom: "20px"}} variant="standard">
                                <InputLabel htmlFor="nRamales">Número de ramales por línea de cultivo*</InputLabel>
                                <Input
                                    id="nRamales"
                                    className="t4b-finca-sector-inputs"
                                    label="Número Ramales"
                                    value={state.nRamales}
                                    onChange={(e) => handleChangeNRamales(e.target.value)}
                                    required
                                    name="nRamales"
                                    error={errors.errorNRamales}
                                />
                                {errors.errorNRamalesMsg && <div className="errorInput">{errors.errorNRamalesMsg}</div>}
                        </FormControl>
                        <FormControl sx={{width: "100%", marginBottom: "20px"}} variant="standard">
                                <InputLabel htmlFor="distanciaGoteros">Distancia entre goteros (metros)*</InputLabel>
                                <Input
                                    id="distanciaGoteros"
                                    className="t4b-finca-sector-inputs"
                                    label="Distancia entre gotero"
                                    value={state.distanciaGoteros}
                                    onChange={(e) => handleChangeDistanciaGoteros(e.target.value)}
                                    required
                                    name="distanciaGoteros"
                                    error={errors.errorDistanciaGoteros}
                                />
                                {errors.errorDistanciaGoterosMsg && <div className="errorInput">{errors.errorDistanciaGoterosMsg}</div>}
                        </FormControl>
                    </>
                    )}
                    {state.tipoRiego === "Goteros por árbol" && (
                        <>
                            <FormControl sx={{width: "100%", marginBottom: "20px"}} variant="standard">
                                <InputLabel htmlFor="nGoteros">Número de Goteros por Árbol*</InputLabel>
                                <Input
                                    id="nGoteros"
                                    className="t4b-finca-sector-inputs"
                                    label="Número de Goteros"
                                    value={state.nGoteros}
                                    onChange={(e) => handleChangeNGoteros(e.target.value)}
                                    required
                                    name="nGoteros"
                                    error={errors.errorNGoteros}
                                />
                                {errors.errorNGoterosMsg && <div className="errorInput">{errors.errorNGoterosMsg}</div>}
                            </FormControl>
                        </>
                    )}

                </>
                }
                
                {(state.tipoCultivo === "olivar" || state.tipoCultivo === "citricos") &&
                <>
                    <h2>Estrategia de Riego</h2>
                    
                    <FormControl sx={{width: "100%", marginBottom: "20px"}} className="radio-green" variant="standard">
                        <FormLabel htmlFor="tipoEstrategia">Estrategia de Riego*</FormLabel>
                        <RadioGroup
                            name="tipoEstrategia"
                            id="tipoEstrategia"
                            value={state.tipoEstrategia}
                            onChange={(e) => handleChangeTipoEstrategia(e.target.value)}
                            error={errors.errorTipoEstrategia ? "true" : ""}
                        >
                            <FormControlLabel value="Necesidades completas (NC)" control={<Radio />} label="Necesidades completas (NC)" />
                            <FormControlLabel value="Riego deficitario sostenido (RDS)" control={<Radio />} label="Riego deficitario sostenido (RDS)" />
                            {(state.tipoCultivo === "citricos" ) &&
                            <FormControlLabel value="Riego deficitario controlado Cítricos (RDCc)" control={<Radio />} label="Riego deficitario controlado Cítricos (RDCc)" />
                            }
                            {(state.tipoCultivo === "olivar" ) &&
                            <FormControlLabel value="Riego deficitario controlado Olivar (RDCo)" control={<Radio />} label="Riego deficitario controlado Olivar (RDCo)" />
                            }
                        </RadioGroup>
                        {errors.errorTipoEstrategiaMsg && <div className="errorMsg">{errors.errorTipoEstrategiaMsg}</div>}
                    </FormControl>

                    {state.tipoEstrategia === "Riego deficitario sostenido (RDS)" && (
                    <FormControl sx={{width: "100%", marginBottom: "20px"}} variant="standard">
                            <InputLabel htmlFor="riegoACubrir">Porcentaje de Necesidades de Riego a Cubrir*</InputLabel>
                            <Input
                                id="riegoACubrir"
                                className="t4b-finca-sector-inputs"
                                label="% Necesidades de riego a cubrir"
                                value={state.riegoACubrir}
                                onChange={(e) => handleChangeRiegoACubrir(e.target.value)}
                                required
                                name="riegoACubrir"
                                error={errors.errorRiegoACubrir}
                            />
                            {errors.errorRiegoACubrirMsg && <div className="errorInput">{errors.errorRiegoACubrirMsg}</div>}
                    </FormControl>

                    )}
                </>
                }

                <Stack spacing={2} direction="row" justifyContent="space-between" className="tic4bio-sectores-btns">
                    <button className="btn white" onClick={(e) => handlePrev(e)} >Anterior</button>
                    <button className="btn green" onClick={(e) => handleNext(e)} style={{margin: "16px 0"}}>Siguiente</button>
                </Stack>
        </Box>
            
            
        </>
    );
}

export default FormRedRiegoComponent;